import jQuery, { get } from "jquery";
window.$ = jQuery;
// import Swiper JS

$(".accordion-open-all").on("click", function () {
    const $accordion = $("#accordion-faq");

    const $panels = $accordion.find(".collapse");

    // Check if any panel is hidden
    const anyHidden = $panels.not(".show").length > 0;

    if (anyHidden) {
        $(".accordion-open-all .open-all").toggleClass("d-none");
        $(".accordion-open-all .close-all").toggleClass("d-none");
        // Temporarily remove data-parent to allow multiple panels open
        $panels.each(function () {
            $(this).removeAttr("data-parent");
        });

        // Show all panels
        $panels.collapse("show");

        // Restore data-parent after showing
        $panels.each(function () {
            $(this).attr("data-parent", "#accordion-faq");
        });
    } else {
        $(".accordion-open-all .open-all").toggleClass("d-none");
        $(".accordion-open-all .close-all").toggleClass("d-none");
        // Hide all panels normally
        $panels.collapse("hide");
    }
});
document.addEventListener("DOMContentLoaded", function () {
    var hash = window.location.hash;
    //console.log(hash);
    if (hash && hash.match(/^#[\w-]+$/)) {
        var faqcard = document.querySelector(".faq-accordion " + hash);
        if (faqcard) {
            var collapseDiv = faqcard.querySelector(".collapse");
            if (collapseDiv) {
                $(collapseDiv).collapse("show");
                collapseDiv.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    }
});
document.addEventListener("DOMContentLoaded", function () {
    var firstCollapse = document.querySelector(".faq-accordion .collapse");
    if (firstCollapse) {
        $(firstCollapse).collapse("show");
    }
});
